import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

function Ico({ children, className = 'h-5 w-5' }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true">{children}</svg>
  );
}
function PhoneIcon({ className }) { return <Ico className={className}><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.9Z"/></Ico>; }
function MessageIcon({ className }) { return <Ico className={className}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></Ico>; }
function VideoIcon({ className }) { return <Ico className={className}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></Ico>; }
function VoicemailIcon({ className }) { return <Ico className={className}><circle cx="5.5" cy="11.5" r="4.5"/><circle cx="18.5" cy="11.5" r="4.5"/><line x1="5.5" y1="16" x2="18.5" y2="16"/></Ico>; }
function KeyboardIcon({ className }) { return <Ico className={className}><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8"/></Ico>; }
function StarIcon({ className }) { return <Ico className={className}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></Ico>; }
function SettingsIcon({ className }) { return <Ico className={className}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></Ico>; }
function SlackIcon({ className }) {
  return (
    <svg viewBox="0 0 54 54" fill="none" className={className} aria-hidden="true">
      <path d="M19.7 33.5a4.3 4.3 0 1 1-4.3-4.3h4.3v4.3z" fill="#E01E5A"/>
      <path d="M21.9 33.5a4.3 4.3 0 0 1 8.6 0v10.7a4.3 4.3 0 1 1-8.6 0V33.5z" fill="#E01E5A"/>
      <path d="M26.2 19.7a4.3 4.3 0 1 1 4.3-4.3v4.3h-4.3z" fill="#36C5F0"/>
      <path d="M26.2 21.9a4.3 4.3 0 0 1 0 8.6H15.5a4.3 4.3 0 1 1 0-8.6h10.7z" fill="#36C5F0"/>
      <path d="M40 26.2a4.3 4.3 0 1 1 4.3 4.3H40v-4.3z" fill="#2EB67D"/>
      <path d="M37.8 26.2a4.3 4.3 0 0 1-8.6 0V15.5a4.3 4.3 0 1 1 8.6 0v10.7z" fill="#2EB67D"/>
      <path d="M33.5 40a4.3 4.3 0 1 1-4.3 4.3V40h4.3z" fill="#ECB22E"/>
      <path d="M33.5 37.8a4.3 4.3 0 0 1 0-8.6h10.7a4.3 4.3 0 1 1 0 8.6H33.5z" fill="#ECB22E"/>
    </svg>
  );
}
function ChevronIcon({ className, open }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round"
      className={`${className} transition-transform duration-200 ${open ? 'rotate-180' : ''}`}>
      <path d="m6 9 6 6 6-6"/>
    </svg>
  );
}

const SECTIONS = [
  {
    id: 'softphone',
    icon: PhoneIcon,
    label: 'Softphone',
    color: 'text-emerald-400',
    bg: 'bg-emerald-500/10',
    border: 'border-emerald-500/20',
    items: [
      {
        q: 'Making an outbound call',
        a: 'Type a phone number in the dial input at the top of the Softphone panel (or click dialpad keys), then press the green Call button or hit Cmd + Enter. The status dot will show "Dialing" then "Ringing" then "Connected" once the call is answered.',
      },
      {
        q: 'Receiving an inbound call',
        a: 'An incoming call shows a centered overlay with the caller\'s number, pulsing rings, and two buttons: Decline (red) and Answer (green). Click Answer or press Cmd + Enter to connect. If you\'re on another tab, a browser notification will pop up. Click it to jump back to the app.',
      },
      {
        q: 'Mute and hold during a call',
        a: 'While on a call, use the Mute button (microphone icon) to silence your mic. The button turns red when active. Use the Hold button (pause icon) to place the caller on hold music. Both can be toggled on and off at any time.',
      },
      {
        q: 'Transferring a call',
        a: 'During an active call, click the Transfer button (arrow icon). Enter the destination number or extension and press Transfer. The call will be handed off and your session will end.',
      },
      {
        q: 'Ending a call',
        a: 'Click the red End Call button at any time. The call status returns to idle and the recent call log updates automatically.',
      },
      {
        q: 'SIP registration status',
        a: 'The status dot below the dial input shows your connection state. Green "Ready" means your SIP client is registered and ready to make and receive calls. If it shows "Offline" or "Error", refresh the page. The client will reconnect automatically.',
      },
    ],
  },
  {
    id: 'sms',
    icon: MessageIcon,
    label: 'SMS Messaging',
    color: 'text-sky-400',
    bg: 'bg-sky-500/10',
    border: 'border-sky-500/20',
    items: [
      {
        q: 'Finding the Messages panel',
        a: 'Messages are embedded directly in the Softphone tab. Look for the panel in the top-right section of the Softphone layout. No need to navigate away from the main screen.',
      },
      {
        q: 'Receiving an inbound SMS',
        a: 'Inbound messages appear instantly in the conversation list. A pulsing blue badge on the Softphone nav tab shows unread count. Click a conversation to open it. Messages auto-mark as read when the thread is opened.',
      },
      {
        q: 'Sending a reply',
        a: 'Open a conversation, type your message in the compose box at the bottom, and press Enter or click Send. Outbound messages show immediately in the thread. Note: outbound delivery requires 10DLC carrier registration (see below).',
      },
      {
        q: 'Starting a new conversation',
        a: 'Use the New Conversation button at the top of the messages list. Enter the destination number in E.164 format (e.g. +17025551234) and type your first message.',
      },
      {
        q: '10DLC and outbound delivery',
        a: 'US carriers require A2P SMS from 10-digit numbers to be 10DLC-registered before they\'ll deliver messages. Inbound works without registration. To enable outbound: log in to the Telnyx portal, go to Messaging, then 10DLC, and register a Brand, a Campaign, then assign your number. Approval takes 24 to 72 hours.',
      },
    ],
  },
  {
    id: 'video',
    icon: VideoIcon,
    label: 'Video Rooms',
    color: 'text-violet-400',
    bg: 'bg-violet-500/10',
    border: 'border-violet-500/20',
    items: [
      {
        q: 'Starting an instant video call',
        a: 'Go to the Video Call tab and click New Video Call. The system creates a room instantly, joins you as the host, and shows your video tile. Share the room link (copy via the Upcoming Calls card) with anyone you want to invite.',
      },
      {
        q: 'Joining a room as a guest',
        a: 'Open the join link in any browser. No login required. You\'ll land on the video lobby page, grant camera and microphone access, and connect to the room. Both sides will see each other\'s video tiles.',
      },
      {
        q: 'Scheduling a call',
        a: 'Click the Schedule Call button in the Video Call tab. Fill in the title (required), date and time (required, must be at least 1 minute in the future), optional invite emails, and max participants (2 to 10). Click Schedule. The room appears in your Upcoming Calls list.',
      },
      {
        q: 'Joining a scheduled call',
        a: 'In the Upcoming Calls card, each scheduled room shows a Join button. It becomes active 5 minutes before the scheduled time. Click Join to enter the room directly. No separate link needed.',
      },
      {
        q: 'Camera not found',
        a: 'If your device has no camera or camera access is blocked, the system automatically falls back to audio-only mode. You\'ll still be connected and heard. Your video tile just won\'t show a feed. To enable video, allow camera access in your browser settings and rejoin.',
      },
      {
        q: 'Mute and video controls in a call',
        a: 'During a video call, use the mic button to mute/unmute and the camera button to turn video on/off. The End Call button disconnects you from the room.',
      },
    ],
  },
  {
    id: 'voicemail',
    icon: VoicemailIcon,
    label: 'Voicemail',
    color: 'text-amber-400',
    bg: 'bg-amber-500/10',
    border: 'border-amber-500/20',
    items: [
      {
        q: 'How voicemail works',
        a: 'If an inbound call goes unanswered for 25 seconds, it is automatically routed to voicemail. The caller can leave a message which is recorded and stored in your account.',
      },
      {
        q: 'Viewing and playing voicemails',
        a: 'Go to the Voicemail tab. New voicemails are listed with caller number, date and time, and duration. A flashing red badge on the Voicemail tab shows unread count. It clears when you open the tab. Click the play button on any voicemail to listen.',
      },
      {
        q: 'Deleting a voicemail',
        a: 'Click the trash icon on a voicemail. A confirmation button appears. Click Delete to confirm or X to cancel. Deleted voicemails are permanently removed.',
      },
      {
        q: 'Unread badge',
        a: 'The red pulsing badge on the Voicemail nav tab shows how many unread voicemails you have. It resets to zero when you open the Voicemail tab, not when you play individual messages.',
      },
    ],
  },
  {
    id: 'slack',
    icon: SlackIcon,
    label: 'Slack',
    color: 'text-[#E01E5A]',
    bg: 'bg-pink-500/10',
    border: 'border-pink-500/20',
    items: [
      {
        q: 'Connecting your Slack workspace',
        a: 'Go to Settings (gear icon in the top nav) and scroll to the Slack section. Click "Connect Slack". You\'ll be sent to Slack\'s authorization page where you approve access for your workspace. After approving, you\'ll land back in the dashboard automatically.',
      },
      {
        q: 'Picking a channel to display',
        a: 'After connecting, a channel dropdown appears in Settings under the Slack section. Click "Load channels" if the list is not already visible, then select the channel you want to monitor. Your choice is saved immediately and messages from that channel will appear in the Softphone panel.',
      },
      {
        q: 'Where do messages appear?',
        a: 'Once a channel is selected, live messages appear in the bottom-right card of the Softphone tab. The card header shows the channel name and your workspace name. Messages refresh automatically every 30 seconds and also refresh immediately after you send a reply.',
      },
      {
        q: 'Replying from the softphone panel',
        a: 'Type in the reply input at the bottom of the Slack card and press Enter or click the send button. Your message posts directly to the connected Slack channel. The feed refreshes right away so you can see it appear.',
      },
      {
        q: 'Changing the channel',
        a: 'Go to Settings, find the Slack section, and use the channel dropdown to pick a different channel. The change takes effect immediately.',
      },
      {
        q: 'Disconnecting Slack',
        a: 'Go to Settings, scroll to the Slack section, and click "Disconnect Slack" at the bottom of the connected state. This removes your access token and clears the feed. You can reconnect at any time by going through the Connect flow again.',
      },
      {
        q: 'Does each user connect their own Slack?',
        a: 'Yes. Each ONLYnumber account connects its own Slack workspace independently. Your connection is private to your account. Other users on the same ONLYnumber plan connect their own workspaces separately.',
      },
    ],
  },
  {
    id: 'settings',
    icon: SettingsIcon,
    label: 'Settings',
    color: 'text-slate-400',
    bg: 'bg-slate-500/10',
    border: 'border-slate-500/20',
    items: [
      {
        q: 'Connecting your Telnyx account',
        a: 'Go to Settings and find the "Connect Telnyx Account" section. Paste your Telnyx API key (found in the Telnyx portal under API Keys) and click Connect. The system will import your phone numbers and configure your SIP credentials automatically.',
      },
      {
        q: 'Viewing your phone numbers',
        a: 'Your connected numbers appear in the Phone Numbers section at the top of Settings. Each number shows its assignment status. Assigned numbers are active for calls and SMS. Available numbers are imported but not yet active.',
      },
      {
        q: 'Carrier status',
        a: 'The Carrier Status section shows whether your Telnyx account is connected, how many numbers are imported, and your SIP connection ID. If it shows "Not Connected", use the Connect Telnyx Account form below it.',
      },
      {
        q: 'Connecting Slack',
        a: 'The Slack section in Settings lets you connect your Slack workspace, pick a channel, and disconnect. See the Slack section of this help guide for the full walkthrough.',
      },
      {
        q: 'Where is the Settings page?',
        a: 'Click the gear icon in the top-right of the navigation bar. Settings opens as a full panel within the dashboard. There is no separate page. Use the X or navigate to another tab to close it.',
      },
    ],
  },
  {
    id: 'partners',
    icon: StarIcon,
    label: 'Partner Program',
    color: 'text-purple-400',
    bg: 'bg-purple-500/10',
    border: 'border-purple-500/20',
    items: [
      {
        q: 'What is the Partner Program?',
        a: 'If you have a partner agreement with ONLYnumber, your account is fully unlocked at no cost. In exchange, you share your unique invite link with your audience and earn a revenue share percentage on every paying subscriber who signs up through your link, for as long as they stay a customer.',
      },
      {
        q: 'Where do I find my invite link?',
        a: 'Open the Partner tab in the left nav (star icon, only visible on partner accounts). Your link is shown at the top: onlynumber.online/signup?ref=YOURCODE. Click Copy Link to copy the full URL, or click your code chip to copy just the code.',
      },
      {
        q: 'How does referral tracking work?',
        a: 'When someone clicks your link the referral code is saved automatically. Even if they close the tab and return later the code persists. When they complete signup the account is permanently credited to you. No action needed on your end.',
      },
      {
        q: 'How is my commission calculated?',
        a: 'Your commission is a percentage of the monthly revenue your referred users generate. At 20% commission, if your referrals pay a combined $200 per month you earn $40 that month. Free plan users contribute $0. The amount adjusts automatically when users upgrade or downgrade.',
      },
      {
        q: 'When do I get paid?',
        a: 'Payouts are processed by the ONLYnumber team. Once a payment is sent your ledger updates showing the amount and method. Check Commission History in your Partner tab to see all past payouts and your current balance owed.',
      },
      {
        q: 'What does the Partner tab show me?',
        a: 'Your Partner tab shows: invite link and code, your commission rate, total earned and paid out and currently owed, this month\'s accrual progress, full commission ledger with paid vs. pending status, and a list of every referred user with their current plan and your monthly cut from each.',
      },
    ],
  },
  {
    id: 'shortcuts',
    icon: KeyboardIcon,
    label: 'Keyboard Shortcuts',
    color: 'text-rose-400',
    bg: 'bg-rose-500/10',
    border: 'border-rose-500/20',
    items: [
      {
        q: 'Cmd + Enter',
        a: 'Answer an incoming call (when ringing) or place a call (when a number is entered in the dial input and no call is active).',
      },
      {
        q: 'Cmd + D',
        a: 'Focus the dial input so you can start typing a number immediately without clicking.',
      },
      {
        q: 'Enter (in dial input)',
        a: 'Place a call using the number currently in the dial input.',
      },
      {
        q: 'Enter (in Schedule Call modal)',
        a: 'Submit the schedule form. Equivalent to clicking the Schedule button.',
      },
      {
        q: 'Enter (in Slack reply input)',
        a: 'Send your message to the connected Slack channel. Use Shift + Enter for a new line without sending.',
      },
    ],
  },
];

function Section({ section, theme }) {
  const [openIdx, setOpenIdx] = useState(null);
  const isDark = theme === 'dark';
  const panel   = isDark ? 'bg-black/40 border-white/10'  : 'bg-white border-slate-200';
  const muted   = isDark ? 'text-white/40'                : 'text-slate-400';
  const rowHover= isDark ? 'hover:bg-white/[0.04]'        : 'hover:bg-slate-50';
  const divider = isDark ? 'border-white/[0.06]'          : 'border-slate-100';
  const answerBg= isDark ? 'bg-white/[0.04]'              : 'bg-slate-50';

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: EASE }}
      className={`rounded-[24px] border overflow-hidden ${panel}`}
    >
      {/* Section header */}
      <div className={`flex items-center gap-3 px-6 py-4 border-b ${divider}`}>
        <div className={`p-2 rounded-xl ${section.bg} border ${section.border}`}>
          <section.icon className={`h-4 w-4 ${section.color}`} />
        </div>
        <span className="font-semibold text-sm tracking-wide">{section.label}</span>
      </div>

      {/* Q&A rows */}
      <div>
        {section.items.map((item, idx) => (
          <div key={idx} className={`border-b last:border-b-0 ${divider}`}>
            <button
              onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              className={`w-full flex items-center justify-between px-6 py-4 text-left transition-colors ${rowHover}`}
            >
              <span className="text-sm font-medium pr-4">{item.q}</span>
              <ChevronIcon className={`h-4 w-4 flex-shrink-0 ${muted}`} open={openIdx === idx} />
            </button>
            <AnimatePresence initial={false}>
              {openIdx === idx && (
                <motion.div
                  key="answer"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.22, ease: EASE }}
                  className="overflow-hidden"
                >
                  <div className={`px-6 pb-5 pt-1`}>
                    <p className={`text-sm leading-relaxed ${muted} ${answerBg} rounded-xl px-4 py-3`}>
                      {item.a}
                    </p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </motion.div>
  );
}

export default function Help({ theme = 'dark', isPartner = false }) {
  const [activeSection, setActiveSection] = useState(null);
  const isDark = theme === 'dark';
  const muted  = isDark ? 'text-white/40' : 'text-slate-400';
  const pill   = isDark
    ? 'bg-white/[0.07] hover:bg-white/[0.12] border-white/10'
    : 'bg-slate-100 hover:bg-slate-200 border-slate-200';
  const pillActive = isDark
    ? 'bg-white/[0.15] border-white/20'
    : 'bg-slate-200 border-slate-300';

  // Hide Partner Program section from non-partner users
  const allowedSections = SECTIONS.filter(s => s.id !== 'partners' || isPartner);

  const visibleSections = activeSection
    ? allowedSections.filter(s => s.id === activeSection)
    : allowedSections;

  return (
    <div className="h-full overflow-y-auto px-1 pb-8">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-2xl font-semibold tracking-tight">Help & Documentation</h2>
        <p className={`text-sm mt-1 ${muted}`}>ONLYnumber v6.0 — quick reference for every feature</p>
      </div>

      {/* Filter pills */}
      <div className="flex flex-wrap gap-2 mb-6">
        <button
          onClick={() => setActiveSection(null)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${activeSection === null ? pillActive : pill}`}
        >
          All
        </button>
        {allowedSections.map(s => (
          <button
            key={s.id}
            onClick={() => setActiveSection(activeSection === s.id ? null : s.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${activeSection === s.id ? pillActive : pill}`}
          >
            <s.icon className={`h-3 w-3 ${s.color}`} />
            {s.label}
          </button>
        ))}
      </div>

      {/* Sections */}
      <div className="flex flex-col gap-4">
        {visibleSections.map(section => (
          <Section key={section.id} section={section} theme={theme} />
        ))}
      </div>

      {/* Footer */}
      <div className={`mt-8 text-center text-xs ${muted}`}>
        ONLYnumber · v6.0 · onlynumber.online
      </div>
    </div>
  );
}
